import { OrderedCapacityType } from '@gasbi/shared/common/features';

export const MONTHS_UA = [
  'січень',
  'лютий',
  'березень',
  'квітень',
  'травень',
  'червень',
  'липень',
  'серпень',
  'вересень',
  'жовтень',
  'листопад',
  'грудень',
] as const;

export const MONTHS_EN = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
] as const;

export const MONTHS_RECORD: Record<
  (typeof MONTHS_EN)[number],
  (typeof MONTHS_UA)[number]
> = {
  january: 'січень',
  february: 'лютий',
  march: 'березень',
  april: 'квітень',
  may: 'травень',
  june: 'червень',
  july: 'липень',
  august: 'серпень',
  september: 'вересень',
  october: 'жовтень',
  november: 'листопад',
  december: 'грудень',
};

export const adjustmentsByOrderedCapacityType: Partial<
  Record<OrderedCapacityType, OrderedCapacityType[]>
> = {
  [OrderedCapacityType.AutoCalculatedByDefault]: [
    OrderedCapacityType.AdjustmentFirst,
  ],
  [OrderedCapacityType.ApplicationNewCounterparty]: [
    OrderedCapacityType.AdjustmentFirstByCounterparty,
    OrderedCapacityType.AdjustmentSecondByCounterparty,
  ],
  [OrderedCapacityType.ApplicationNewMeteringPoint]: [
    OrderedCapacityType.AdjustmentFirstByMeteringPoint,
    OrderedCapacityType.AdjustmentSecondByMeteringPoint,
  ],
  [OrderedCapacityType.AdjustmentFirst]: [OrderedCapacityType.AdjustmentSecond],
  [OrderedCapacityType.AdjustmentFirstByCounterparty]: [
    OrderedCapacityType.AdjustmentSecondByCounterparty,
  ],
  [OrderedCapacityType.AdjustmentFirstByMeteringPoint]: [
    OrderedCapacityType.AdjustmentSecondByMeteringPoint,
  ],
};

export const adjustmentFirstTypes: OrderedCapacityType[] = [
  OrderedCapacityType.AdjustmentFirst,
  OrderedCapacityType.AdjustmentFirstByCounterparty,
  OrderedCapacityType.AdjustmentFirstByMeteringPoint,
];

export const adjustmentSecondTypes: OrderedCapacityType[] = [
  OrderedCapacityType.AdjustmentSecond,
  OrderedCapacityType.AdjustmentSecondByCounterparty,
  OrderedCapacityType.AdjustmentSecondByMeteringPoint,
];

export const adjustmentTypes = [
  ...new Set(Object.values(adjustmentsByOrderedCapacityType).flat()),
];
